import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Radio } from "./components/Radio";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var RadioGroup = /*#__PURE__*/memo(function (_ref) {
  var items = _ref.items,
    labelwrap = _ref.labelwrap,
    name = _ref.name,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return false;
    } : _ref$onChange,
    _ref$radioVariant = _ref.radioVariant,
    radioVariant = _ref$radioVariant === void 0 ? 'default' : _ref$radioVariant,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    value = _ref.value,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'RadioGroup' : _ref$testName,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'vertical' : _ref$position;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('radio-group', {
      'radio-group--color': radioVariant === 'color',
      'radio-group--horizontal': position === 'horizontal'
    }),
    "data-component": testName
  }, items.map(function (_ref2, index) {
    var disabled = _ref2.disabled,
      label = _ref2.label,
      itemValue = _ref2.itemValue,
      color = _ref2.color;
    return /*#__PURE__*/React.createElement("li", {
      className: cn('radio-group__item', {
        'radio-group__item--color': radioVariant === 'color',
        'radio-group__item--horizontal': position === 'horizontal'
      }),
      key: index
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: value === itemValue,
      color: color,
      disabled: disabled,
      label: label,
      labelwrap: labelwrap,
      name: name,
      onChange: onChange,
      radioVariant: radioVariant,
      size: size,
      value: itemValue
    }));
  }));
});